export const isDev =
  process.env.NODE_ENV !== 'production' ||
  process.env.IS_SLINGSHOT === 'true' ||
  process.env.LOCAL === 'true';
